import PageHeader from "../components/PageHeader";
import HireFullStackDeveloperContent from "../components/HireFullStackDeveloper-Content";

const HireFullStackDevelopers = () => {
    return (
        <>
            <PageHeader pagetitle="Full Stack Developer" breadcrumbMenu="Home" breadcrumbMenuActive="Full Stack Developer" image="/images/full-stack-web-development.jpg" />
            <HireFullStackDeveloperContent />
        </>
    )
}

export default HireFullStackDevelopers;